import { render, staticRenderFns } from "./LoginAsStudent.vue?vue&type=template&id=be3c1a72&scoped=true"
import script from "./LoginAsStudent.vue?vue&type=script&lang=js"
export * from "./LoginAsStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3c1a72",
  null
  
)

export default component.exports